import type { Deal } from '../../types/Deal';
import type { DealImage } from '../../types/DealImage';
import getImageUrl from '../getImageUrl';
import getShortName from '../getShortName';

import { updateImageSize } from './updateImageSize';

export const getDealImage = (
  deal: Deal,
  defaultPriority?: string[],
  width?: number,
  useViewSimilarPriorityFilter = true,
): DealImage => {
  let priority = defaultPriority || ['product', 'label', 'model', 'placeholder'];

  // Only show the placeholder image for view similars
  if (deal?.product_type && deal.product_type === 200 && useViewSimilarPriorityFilter) {
    priority = priority.filter((priority) => !['product', 'label', 'model'].includes(priority));
  }

  return priority.reduce(
    (value: DealImage, currentPriority: string) => {
      if (!value.url) {
        // Get the product image
        // If not found use the model label image
        // If not found use the default model image
        // Or use the placeholder image
        if (currentPriority === 'product' && deal?.image) {
          return {
            url: width ? updateImageSize(deal.image, width, true) : deal.image,
            alt: getShortName(deal?.offer?.name, 30, '...'),
            type: currentPriority,
          };
        }
        if (currentPriority === 'label' && deal.label_image) {
          return {
            url: width ? updateImageSize(deal.label_image, width, true) : deal.label_image,
            alt: getShortName(deal.offer && deal.offer.name, 30, '...'),
            type: currentPriority,
          };
        }
        if (currentPriority === 'model' && deal.model_image) {
          return {
            url: width ? updateImageSize(deal.model_image, width, true) : deal.model_image,
            alt: getShortName(deal.offer && deal.offer.name, 30, '...'),
            type: currentPriority,
          };
        }
        if (currentPriority === 'merchant' && deal.merchant && deal.merchant.logo_url) {
          return {
            url: width
              ? updateImageSize(deal.merchant.logo_url, width, true)
              : deal.merchant.logo_url,
            alt: getShortName(deal.merchant && String(deal.merchant.name), 30, '...'),
            type: currentPriority,
          };
        }
        if (currentPriority === 'network' && deal.contract && deal.contract.network_logo_url) {
          return {
            url: width
              ? updateImageSize(deal.contract.network_logo_url, width, true)
              : deal.contract.network_logo_url,
            alt: getShortName(deal.contract && deal.contract.network, 30, '...'),
            type: currentPriority,
          };
        }
        if (currentPriority === 'placeholder') {
          return {
            url: getImageUrl('misc/no-image-available.svg'),
            alt: getShortName(deal.offer && deal.offer.name, 30, '...'),
            type: currentPriority,
          };
        }
      }
      return value;
    },
    {
      url: '',
      alt: '',
      type: '',
    },
  );
};
